module.exports = __webpack_public_path__ + "static/media/need-more-help.9acf76d3.png";